import type { ReferenceGraphemeMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { useMorphemeInfoPanelCaligraphyStrokesSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.caligraphy.__sections.strokes";

/**
 * This tab's sections as descriptors; see the dictionary equivalent for why it lives here.
 * Evolution (`__sections/evolution`) is disabled for now.
 */
export function useMorphemeInfoPanelCaligraphyGraphemeSections({
  graphemeCard,
}: {
  graphemeCard: ReferenceGraphemeMorphemeSlice;
}): MorphemeInfoPanelAccordionSectionDescriptor[] {
  const strokes = useMorphemeInfoPanelCaligraphyStrokesSection({ graphemeCard });
  return strokes === null ? [] : [strokes];
}
